import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'OrdersPage';

/**
 * Errors related to the Order History page
 */
export const Errors = createErrors<Page, Component>('OrderHistory')({
    OrdersPage: {
        FetchFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch orders',
        },
    },
});
